// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2aU76","consentsList":"PatientConsents_consentsList__3KFKe","consentsListEmpty":"PatientConsents_consentsListEmpty__1m1xf"};